import clsx from "clsx";
import React, { FC } from "react";

import { colorScheme } from "./styles";
import { PaginationBarColor } from "./types";

export interface PaginationBarProps {
  color?: PaginationBarColor;
  activeItem: number;
  totalItems: number;
  className?: string;
}

export const PaginationBar: FC<PaginationBarProps> = ({
  color = PaginationBarColor.Primary,
  totalItems,
  activeItem,
  className,
}) => {
  const { indicatorClassName, bgClassName } = colorScheme[color];
  return (
    <div
      className={clsx(
        "flex w-full h-[5px] overflow-hidden relative",
        totalItems > 1 && bgClassName,
        className
      )}
    >
      <div
        className={clsx(
          "transition-all duration-300 absolute top-0 h-[5px]",
          totalItems > 1 && indicatorClassName
        )}
        style={{
          left: `${(activeItem / totalItems) * 100}%`,
          width: `${(1 / totalItems) * 100}%`,
        }}
      />
    </div>
  );
};
